import { Routes, Route } from "react-router";
import { DesignLabRoute } from "./DesignLabRoute";
import { TransfersLabRoute } from "./TransfersLabRoute";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/design-lab/:uuid?" Component={DesignLabRoute}></Route>
      <Route path="/transfers-lab" Component={TransfersLabRoute}></Route>
    </Routes>
  );
}
